module.exports = __webpack_public_path__ + "img/empty.5e3bcc3c.png";